import { ModelManipulator } from '@blazemeter/blaze-data-designer-client';
import { assetRepoFetch, dataDesignerFetch } from 'axios/tdm-http-client';
import { AssetRepositoryClient } from '@blazemeter/asset-repository-lib/lib/client/asset-repository-client';
import { DataDesignerClientAr } from '@blazemeter/blaze-data-designer-client/lib/client/DataDesignerClientAr';

class BlazeDataClient {
  client: DataDesignerClientAr;
  manipulator: ModelManipulator;
  arClient: AssetRepositoryClient;

  constructor() {
    this.client = {} as any; // So we do not have to check for nulls all the time
    this.manipulator = {} as any;
    this.arClient = {} as any;
  }

  createClient(workspaceId: number) {
    this.arClient = new AssetRepositoryClient('/api/v1/', workspaceId, assetRepoFetch);
    this.client = new DataDesignerClientAr('/api/v1/', workspaceId, dataDesignerFetch, this.arClient);
    this.manipulator = new ModelManipulator(this.client);
  }
}
export const blazeDataClient: BlazeDataClient = new BlazeDataClient();
export default blazeDataClient;
